var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { DateFormatterUtil } from '../../utils';
import React, { Component } from 'react';
import { ReactComponent as IntravenousArrowUP } from '../../assets/images/global/IntravenousArrowUP.svg';
import { ReactComponent as IntravenousCancel } from '../../assets/images/global/IntravenousCancel.svg';
import { ReactComponent as IntravenousCircle } from '../../assets/images/global/IntravenousCircle.svg';
import { ReactComponent as IntravenousPartial } from '../../assets/images/global/IntravenousPartial.svg';
import { ReactComponent as IntravenousClockYellow } from '../../assets/images/global/IntravenousClockYellow.svg';
import { ReactComponent as IntravenousMinorWarning } from '../../assets/images/global/IntravenousMinorWarning.svg';
import DevicesCardAPI from './devices-card-api';
import { Text } from '@philips-internal/oswald-ui-components';
import './devices-card.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { bool } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
const legends = [
    {
        color: 'signal-yellow-30',
        icon: React.createElement(IntravenousClockYellow, null),
        label: MessageService.translate('tws.label-to-expire'),
        value: 'tws.label-to-expire'
    },
    {
        color: 'signal-green-60',
        icon: React.createElement(IntravenousPartial, null),
        label: MessageService.translate('tws.label-in-progress'),
        value: 'tws.label-in-progress'
    },
    {
        color: 'signal-green-60',
        icon: React.createElement(IntravenousArrowUP, null),
        label: MessageService.translate('tws.label-high-with-device'),
        value: 'tws.label-high-with-device'
    },
    {
        color: 'signal-yellow-30',
        icon: React.createElement(IntravenousMinorWarning, null),
        label: MessageService.translate('tws.label-expired'),
        value: 'tws.label-expired'
    },
    {
        color: 'signal-gray-60',
        icon: React.createElement(IntravenousCircle, null),
        label: MessageService.translate('tws.label-withdrawn'),
        value: 'tws.label-withdrawn'
    },
    {
        color: 'signal-red-60',
        icon: React.createElement(IntravenousCancel, null),
        label: MessageService.translate('tws.label-unsuccessfully'),
        value: 'tws.label-unsuccessfully'
    }
];
const allowedSuepLegends = ['tws.label-in-progress'];
let DevicesCard = class DevicesCard extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isSuep: this.props.isSuep
        };
        this.handleClick = () => {
            const { onClick, deviceDescription, deviceSequence, topographyDescription, installationDate, encounterCode, patientEncounterDeviceId, status } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        deviceDescription,
                        deviceSequence,
                        encounterCode,
                        installationDate,
                        patientEncounterDeviceId,
                        status,
                        topographyDescription
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        isSuep: bool,
        onClick: eventListener,
    }; }
    static { this.defaultProps = {
        isSuep: false
    }; }
    renderCard() {
        const { installationDate, deviceDescription, topographyDescription } = this.props;
        const formatDateTime = DateFormatterUtil.short(String(installationDate));
        return (React.createElement("div", { className: 'c-devices-card__header__card' },
            React.createElement("div", { className: 'c-devices-card__header' },
                React.createElement("div", { className: 'c-devices-card__hour' },
                    React.createElement(Text, { className: "c-text-hour", value: deviceDescription })),
                React.createElement("div", { className: 'c-devices-card__status' },
                    React.createElement("div", { className: 'c-devices-card-icon' }, this.getStatusIcon()),
                    this.getStatusSecondIcon())),
            React.createElement("div", { className: "c-component-separator" }),
            React.createElement("div", { className: 'c-devices__wrapper' },
                React.createElement("div", { className: 'c-devices-content-item' },
                    React.createElement("div", { className: 'c-devices-content' },
                        React.createElement("div", { className: 'c-devices-content-column' },
                            React.createElement("div", { className: 'c-devices-content-p1' },
                                React.createElement(Text, { value: MessageService.translate('text.installation-date') }),
                                React.createElement(Text, { bold: true, className: "c-text-value", value: formatDateTime })),
                            React.createElement("div", { className: 'c-devices-content-p2' },
                                React.createElement(Text, { value: MessageService.translate('text.topography') }),
                                React.createElement(Text, { bold: true, className: "c-text-value", value: topographyDescription }))))))));
    }
    getStatusSecondIcon() {
        const { statusDisp } = this.props;
        if (statusDisp?.toUpperCase() === 'S') {
            return (React.createElement("div", { className: 'c-devices-card-icon' },
                React.createElement(IntravenousArrowUP, null)));
        }
        return null;
    }
    getStatusIcon() {
        const { status } = this.props;
        switch (status?.toUpperCase()) {
            case 'A':
                return React.createElement(IntravenousPartial, null);
            case 'R':
                return React.createElement(IntravenousCircle, null);
            case 'V':
                return React.createElement(IntravenousMinorWarning, null);
            case 'E':
                return React.createElement(IntravenousClockYellow, null);
            default:
                return null;
        }
    }
    prepareLegends() {
        if (this.state.isSuep) {
            return [...legends].filter(legend => allowedSuepLegends.includes(legend.value));
        }
        return [...legends];
    }
    render() {
        const { deviceId } = this.props;
        return (React.createElement(Card, { className: 'c-devices-main', key: deviceId, selectionType: SelectionType.SINGLE, superscription: this.prepareLegends(), onClick: this.handleClick, uuid: generateUUID(), width: 12 }, this.renderCard()));
    }
};
DevicesCard = __decorate([
    AwesomeComponent({ api: DevicesCardAPI, type: ComponentType.DATA_DISPLAY })
], DevicesCard);
export default DevicesCard;
//# sourceMappingURL=devices-card.js.map